import Pqp from "../../../../3x1010/Pqp";
import QueryResults from "./QueryResults";
import "swiper/swiper-bundle.min.css";
import Swiper, { Navigation, Pagination } from "swiper";
import * as Solr from "../../../../3x1010/Solr.js";
import Game from "../../game/Game.js";

export default class FieldRender {
  constructor(collectionName) {
    this.collectionName = collectionName;
    this.schema = new Solr.Schema(this.collectionName);
  }

  getField(value) {
    if (!value) {
      return [];
    }
    if (Array.isArray(value)) {
      return value;
    }
    return [value];
  }

  getLabel(name, def) {
    //debugger;
    if (QueryResults.READ_COLUMN_HEADER_FROM_SCHEMA) {
      if (Array.isArray(name)) {
        const sch = this.getFieldByNameFromSchema(name[0]);
        if (Pqp.isNullOrEmpty(sch)) {
          return def;
        }
        const a = sch.Fields;
        for (let x = 0; x < a.length; x++) {
          if (a[x].Name == name[1]) {
            return a[x].Label;
          }
        }
        return def;
      } else {
        const sch = this.getFieldByNameFromSchema(name);
        if (Pqp.isNullOrEmpty(sch)) {
          return def;
        }
        return sch.Label;
      }
    }
    return def;
  }

  getFieldByNameFromSchema(name) {
    return this.schema.getFieldByName(name);
  }

  openSwiperCarousel(images) {
    // Crea un contenitore per il modal
    const modal = jQuery("#template-swiper").clone();
    modal.removeAttr("id");
    // Crea le slide
    for (let x = 0; x < images.length; x++) {
      const slide = jQuery("#template-swiper-slide").clone();
      slide.removeAttr("id");
      jQuery(".swiper-image", slide).attr("src", images[x].original_url);
      jQuery(".swiper-wrapper", modal).append(slide);
    }

    // Aggiungi il modal al body
    jQuery("body").append(modal);

    // Inizializza Swiper
    const swiper = new Swiper(jQuery(".swiper-container", modal).get(0), { loop: true });

    jQuery(".js-next", modal).on("click", () => {
      swiper.slideNext();
    });

    jQuery(".js-prev", modal).on("click", () => {
      swiper.slidePrev();
    });

    jQuery(".js-swiper-close", modal).on("click", () => {
      modal.remove();
    });
  }

  /*fixBR(s) {
    return Pqp.safeReplace(s, "<br/>", "<br>");
  }*/

  openPlayer() {
    // Crea un contenitore per il modal
    const modal = jQuery("#template-modal-player").clone();
    modal.removeAttr("id");
    // Aggiungi il modal al body
    jQuery("body").append(modal);

    jQuery(".js-modal-player-close", modal).on("click", () => {
      modal.remove();
    });

    this.createPlayer(modal);
  }

  createPlayer(modal) {
    const player = jQuery("#template-mnc-player").clone();
    player.removeAttr("id");
    modal.append(player);

    const config = {
      target: player.get(0),
      folderPath: "assets_tmp/views/",
      filenamePrefix: "M01279_RV_muto_V-",
      filenameSuffix: ".webp",
      totalFrames: 32,
      finalMaxZoom: 5,
      autoPlayInterval: 100,
      dragThreshold: 20,
      spans: [
        { span: 320, zoomSteps: 0.01 },
        { span: 480, zoomSteps: 0.04 },
        { span: 900, zoomSteps: 0.07 },
        { span: 1080, zoomSteps: 0.1 },
        { span: 1440, zoomSteps: 0.15 },
        { span: 2160, zoomSteps: 0.2 },
        { span: 3240, zoomSteps: 0.3 }, // Da cellulare non regge
      ],
    };

    this.game = new Game(config);
    this.game.init();
  }

  fieldFilmografia() {
    return {
      //headerName: "🎬",
      headerName: " ",
      headerClass: "header-icon-media",
      pinned: "left",
      suppressMenu: true,
      sortable: false, // Disabilita l'ordinamento
      resizable: false,
      width: 52,
      cellRendererSelector: this.renderExpandContent.bind(this),
      suppressSizeToFit: true,
      suppressHeaderContextMenu: true,
    };
  }

  fieldCta(collectionName, callback) {
    return {
      //headerName: "🔍",
      headerName: " ",
      headerClass: "header-icon-search",
      pinned: "left",
      suppressMenu: true,
      sortable: false, // Disabilita l'ordinamento
      resizable: false,
      width: 52,
      cellRenderer: this.renderCta.bind(this, collectionName, callback),
    };
  }

  fieldMedia() {
    // Media (immagine)
    return {
      pathForXls: "/media/preview_url",
      field: "media",
      headerName: this.getLabel("media", "Media"), //"Media",
      autoHeight: true,
      wrapText: true, // Abilita il wrapping del testo nella cella
      sortable: false, // Disabilita l'ordinamento
      cellRenderer: this.renderMedia.bind(this),
      flex: 2,
    };
  }

  filmografiaNCTN() {
    return {
      pathForXls: "/Filmografia/numero_catalogo_generale_NCTN",
      field: "fncnt",
      headerName: "NCTN",
      flex: 1,
      sortable: false,
      cellRenderer: (params) => {
        if (params.data.Filmografia) {
          return params.data.Filmografia[0].numero_catalogo_generale_NCTN;
        }
      },
    };
  }

  filmografiaTitolo() {
    return {
      pathForXls: "/Filmografia/label",
      field: "flabel",
      headerName: "Film",
      flex: 2,
      sortable: false,
      cellRenderer: (params) => {
        if (params.data.Filmografia) {
          return params.data.Filmografia[0].label;
        }
      },
    };
  }

  filmografiaData() {
    return {
      pathForXls: "/Filmografia/cronologia_datazione_scheda_DT/data_DTI",
      field: "fdata",
      headerName: "Data",
      flex: 1,
      sortable: false,
      cellRenderer: (params) => {
        if (params.data.Filmografia) {
          return params.data.Filmografia[0].cronologia_datazione_scheda_DT?.data_DTI;
        }
      },
    };
  }

  filmografiaRegista() {
    return {
      pathForXls: "/Filmografia/registi/label",
      field: "fregia",
      headerName: "Regia",
      flex: 1,
      sortable: false,
      cellRenderer: (params) => {
        if (params.data.Filmografia) {
          const a = this.getField(params.data.Filmografia[0].registi);
          return a.map((item) => item.label).join("<br>");
        }
      },
    };
  }

  fieldPlain(name, defaultLabel, flex, payload = null) {
    let path = "/" + name;

    const ret = { pathForXls: path, field: name, headerName: this.getLabel(name, defaultLabel), flex: flex, sortable: true };
    if (payload) {
      for (let key in payload) {
        ret[key] = payload[key];
      }
    }
    return ret;
  }

  fieldList(nameOrArray, defaultLabel, flex, callback = null, callbackType = null, propToRefer = null, separator = "<br>", filterOn = null, filterValue = null, payload = null, schedaDetails = null) {
    // Se nameOrArray è un array, allora il primo elemento è il nome del campo, il secondo è il nome della proprietà da visualizzare
    // defaultLabel è il nome visualizzato nell'header della colonna (ma viene usato solo se forzato da QueryResults.READ_COLUMN_HEADER_FROM_SCHEMA = false)
    // flex è la larghezza della colonna
    // callback è la funzione da chiamare quando si clicca su un elemento della lista per effettuare la nuova ricerca su quel campo con quel termine (può essere null)
    // callbackType è il tipo che viene passato alla callback e che indica quale query già pronta usare per la ricerca  (può essere null)
    // propToRefer è il nome della proprietà da visualizzare (se non specificato, viene visualizzato l'elemento dell'array, questo perché in alcuni casi l'elemento è un oggetto)
    // Se propToRefer è un array separator è il separatore da usare per concatenare le stringhe
    // filterOn è il nome della proprietà da usare per filtrare l'array (se non specificato, non viene effettuato alcun filtro)
    // filterValue è il valore da usare per filtrare l'array (se non specificato, non viene effettuato alcun filtro)

    let name = nameOrArray;
    if (Array.isArray(nameOrArray)) {
      name = nameOrArray[0];
      //propToRefer = nameOrArray[1];
    }
    // Prova a creare il path
    let path = "/";
    let prop;
    if (Array.isArray(nameOrArray)) {
      prop = nameOrArray[0];
    } else {
      prop = name;
    }
    if (propToRefer) {
      if (!Array.isArray(propToRefer)) {
        path += prop + "/" + propToRefer;
      } else {
        // se è un array deve creare x path
        path += prop + "/" + propToRefer[0];
        for (let x = 1; x < propToRefer.length; x++) {
          path += "|" + "/" + prop + "/" + propToRefer[x];
        }
      }
    } else {
      path += prop;
    }

    /// pezzissima per demo
    let sortable = false;
    if (name === "numero_catalogo_generale_NCTN") {
      sortable = true;
    }

    const ret = {
      pathForXls: path,
      field: name,
      headerName: this.getLabel(nameOrArray, defaultLabel), // Inv. Num.
      flex: flex,
      autoHeight: true,
      wrapText: true, // Abilita il wrapping del testo nella cella
      sortable: sortable, // Disabilita l'ordinamento
      cellRenderer: (params) => {
        const container = document.createElement("div");
        const a = this.getField(params.value);
        a.forEach((item) => {
          //debugger;
          const div = document.createElement("div");
          let lGet = true;
          if (filterOn && filterValue) {
            lGet = item[filterOn] === filterValue;
          }
          if (lGet) {
            div.innerHTML = this.getTextContent(item, propToRefer, separator); //propToRefer ? item[propToRefer] : item;
            //debugger;
            div.title = item?.id ? item.id : "";
            if (item.Entita) {
              if (item.Entita[0]?.intestazione_autorita) {
                div.title = this.cleanHTMLString(item.Entita[0].intestazione_autorita);
              }
            }

            if (callback) {
              div.classList.add("grid-elemento-cliccabile");
              // aggiunge come data-key il valore passato in key dentro schedaDetails
              if (schedaDetails && schedaDetails.key) {
                div.dataset.key = item[schedaDetails.key];
              }

              div.onclick = () => {
                // Teoricamente non dovrebbero esistere dei propToRefer come array se viene passata la callback, quidi me ne infischio ma lo segnalo
                if (Array.isArray(propToRefer)) {
                  console.error("fieldList: propToRefer è un array ma è stata passata una callback");
                }
                if (schedaDetails) {
                  console.log("schedaDetails", schedaDetails);
                  this.openContextualMenu(params, div, schedaDetails, callback, propToRefer, item, callbackType);
                } else {
                  callback.call(null, QueryResults.EVENT_LOOK_FOR, { name: propToRefer ? item[propToRefer] : item, context: params.colDef.headerName, type: callbackType });
                }
              };
            }
            container.appendChild(div);
          }
        });
        return container;
      },
    };

    if (payload) {
      for (let key in payload) {
        ret[key] = payload[key];
      }
    }

    return ret;
  }

  cleanHTMLString(input) {
    const htmlEntities = {
      "&gt;": ">",
      "&lt;": "<",
      "&amp;": "&",
      "&quot;": '"',
      "&#39;": "'",
      // Aggiungi altre entità HTML che vuoi gestire
    };

    return input.replace(/&[a-zA-Z0-9#]+;/g, (match) => htmlEntities[match] || match);
  }

  fieldMultiple(name, defaultLabel, flex, fieldsToRefer = null, separator = "<br>", payload = null) {
    // Nota importante: la differenza tra questo e fieldList è che fieldList è per campi che sono array di oggetti, mentre fieldMultiple è per campi secchi che sono array di stringhe
    // name è il nome del campo dal quale viene letta la label
    // defaultLabel è il nome visualizzato nell'header della colonna (ma viene usato solo se forzato da QueryResults.READ_COLUMN_HEADER_FROM_SCHEMA = false)
    // flex è la larghezza della colonna
    // fieldsToRefer è un array di nomi di campi da visualizzare
    // separator è il separatore da usare per concatenare le stringhe
    let path = "/" + fieldsToRefer[0];
    for (let x = 1; x < fieldsToRefer.length; x++) {
      path += "|/" + fieldsToRefer[x];
    }
    //debugger;

    const ret = {
      pathForXls: path,
      field: name,
      headerName: this.getLabel(name, defaultLabel),
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellRenderer: (params) => {
        let ret = "";
        for (let x = 0; x < fieldsToRefer.length; x++) {
          if (params.data[fieldsToRefer[x]]) {
            ret += "• " + params.data[fieldsToRefer[x]] + separator;
          }
        }
        return ret;
      },
      flex: flex,
    };

    if (payload) {
      for (let key in payload) {
        ret[key] = payload[key];
      }
    }

    return ret;
  }

  getTextContent(item, propToRefer, separator) {
    //    debugger;
    //    console.log(item);
    if (Array.isArray(propToRefer)) {
      // Se propToRefer è un array, allora il primo elemento è il nome della proprietà da visualizzare, il secondo è il separatore
      // Se però uno è undefined, allora non viene usato il separatore e non viene visualizzato
      return propToRefer
        .map((p) => {
          if (item[p]) {
            return "• " + item[p];
          }
          return "";
        })
        .join(separator);
    }
    // se è un oggetto
    if (typeof item === "object") {
      // Se esiste la prop va bene, altrimenti vuoto
      return item[propToRefer] ? "• " + item[propToRefer] : "";
    }
    return "• " + item;
    //return propToRefer ? item[propToRefer] : item;
  }

  renderExpandContent(params) {
    if (params.data.Filmografia && params.data.Filmografia.length > 0) {
      return {
        component: "agGroupCellRenderer", // Usa agGroupCellRenderer solo se ci sono dati
        params: {
          suppressCount: true,
          innerRenderer: (params) => params.value,
        },
      };
    } else {
      return null; // Nessun renderer, quindi nessun pulsante di espansione
    }
  }

  renderMedia(params) {
    const a = this.getField(params.value);
    if (a.length > 0) {
      const entry = a[0];
      // Crea un contenitore div e l'immagine
      const container = document.createElement("div");
      container.classList.add("grid-media-container");
      const img = document.createElement("img");
      img.src = entry.preview_url;
      img.onclick = () => {
        this.openSwiperCarousel(a); // Chiama il metodo per aprire il carousel
      };

      // Aggiunge un numerino che indica il numero di immagini
      if (a.length > 1) {
        const badge = document.createElement("div");
        badge.classList.add("badge-item-counter");
        badge.textContent = a.length;
        container.appendChild(badge);
      }
      container.appendChild(img);
      return container;
    }
    return "";
  }

  renderCta(collectionName, callback, params) {
    const container = document.createElement("div");
    container.classList.add("grid-cta-container", "d-flex-center");
    const cta = document.createElement("div");
    cta.classList.add("grid-cta", "icon-file");
    //cta.textContent = "📄";
    cta.textContent = "";
    cta.onclick = () => {
      callback.call(null, QueryResults.EVENT_OPEN_SCHEDA, { type: QueryResults.SCHEDA_TYPE_COLLECTION, id: params.data.id, collectionName: collectionName });
    };
    container.appendChild(cta);
    return container;
  }

  openContextualMenu(params, div, schedaDetails, callback, propToRefer, item, callbackType) {
    // Crea un contenitore per il modal
    const modal = jQuery("#template-modal-contextual-menu").clone();
    modal.removeAttr("id");
    // Aggiungi il modal al body
    jQuery("body").append(modal);

    jQuery(".js-cm-background", modal).on("click", () => {
      modal.remove();
    });

    // Aggiunge le voci al menu
    let entry = jQuery("#template-modal-contextual-menu-item").clone();
    entry.removeAttr("id");
    //entry.text("Apri scheda");
    entry.html('<span>Apri scheda</span><div class="icon-blank"></div>');
    entry.on("click", () => {
      modal.remove();

      if (div.dataset.key) {
        this.openScheda(params, schedaDetails, callback, div.dataset.key, true);
      } else {
        this.openScheda(params, schedaDetails, callback, propToRefer ? item[propToRefer] : item, false);
      }
    });
    entry.appendTo(jQuery(".js-cm-panel", modal));

    entry = jQuery("#template-modal-contextual-menu-item").clone();
    entry.removeAttr("id");
    //entry.text("Effettua una nuova ricerca");
    entry.html('<span>Effettua una nuova ricerca</span><div class="icon-search"></div>');
    entry.on("click", () => {
      modal.remove();
      callback.call(null, QueryResults.EVENT_LOOK_FOR, { name: propToRefer ? item[propToRefer] : item, context: params.colDef.headerName, type: callbackType });
    });
    entry.appendTo(jQuery(".js-cm-panel", modal));

    // Posiziona il menu

    const panel = jQuery(".js-cm-panel", modal);
    const h = panel.outerHeight();
    const w = panel.outerWidth();

    const rect = div.getBoundingClientRect();

    const top = rect.top - h - 10;
    const left = rect.left - w / 2 + rect.width / 2;

    // Controlla che stia dentro lo schermo
    if (top < 0) {
      top = 0;
    }
    if (left < 0) {
      left = 0;
    }
    if (left + w > window.innerWidth) {
      left = window.innerWidth - w;
    }
    if (top + h > window.innerHeight) {
      top = window.innerHeight - h;
    }
    panel.css("top", top + "px");
    panel.css("left", left + "px");
  }

  openScheda(params, schedaDetails, callback, valueToLookFor, valueOk) {
    //  callback.call(null, QueryResults.EVENT_OPEN_SCHEDA, { type: schedaDetails.type, id: this.getComplexId(params.data, schedaDetails, valueToLookFor) });
    if (valueOk) {
      callback.call(null, QueryResults.EVENT_OPEN_SCHEDA, { type: schedaDetails.type, id: valueToLookFor });
    } else {
      callback.call(null, QueryResults.EVENT_OPEN_SCHEDA, { type: schedaDetails.type, id: this.getComplexId(params.data, schedaDetails, valueToLookFor) });
    }
    //    console.log("openScheda", params, schedaDetails);
  }

  getComplexId(data, schedaDetails, valueToLookFor) {
    // Sto pezzo è un dito dove sai... bisogna rivederlo eventualmente ma con dati più "umani"
    let value = data;
    if (!schedaDetails.key) {
      const props = schedaDetails.prop.split(".");
      for (let i = 0; i < props.length; i++) {
        value = value[props[i]];
        if (value === undefined) {
          return null;
        }
      }
    } else {
      // Deve cercarlo in un array
      const props = schedaDetails.prop.split(".");
      for (let i = 0; i < props.length - 1; i++) {
        value = value[props[i]];
        if (value === undefined) {
          return null;
        }
      }
      const a = this.getField(value);
      // Cerca l'elemento con la key
      for (let x = 0; x < a.length; x++) {
        const val = a[x][schedaDetails.key];
        if (valueToLookFor === val) {
          return a[x][props[props.length - 1]];
        }
      }
    }
    return value;
  }
}
